import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5661%3A6799
 *
 * @param {SvgIconProps} props - svg props
 */
export const LinkIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M3.9 12C3.9 10.29 5.29 8.9 7 8.9H10.5C10.7761 8.9 11 8.67614 11 8.4V7.5C11 7.22386 10.7761 7 10.5 7H7C4.24 7 2 9.24 2 12C2 14.76 4.24 17 7 17H10.5C10.7761 17 11 16.7761 11 16.5V15.6C11 15.3239 10.7761 15.1 10.5 15.1H7C5.29 15.1 3.9 13.71 3.9 12ZM8 12.75C8 12.8881 8.11193 13 8.25 13H15.75C15.8881 13 16 12.8881 16 12.75V11.25C16 11.1119 15.8881 11 15.75 11H8.25C8.11193 11 8 11.1119 8 11.25V12.75ZM17 7H13.5C13.2239 7 13 7.22386 13 7.5V8.4C13 8.67614 13.2239 8.9 13.5 8.9H17C18.71 8.9 20.1 10.29 20.1 12C20.1 13.71 18.71 15.1 17 15.1H13.5C13.2239 15.1 13 15.3239 13 15.6V16.5C13 16.7761 13.2239 17 13.5 17H17C19.76 17 22 14.76 22 12C22 9.24 19.76 7 17 7Z' fill={color}/>
        </SvgIcon>
    )
}

export default LinkIcon
